// extracted by mini-css-extract-plugin
export var icon = "_70-1";
export var subtext = "_70-0";